import { Outlet } from "react-router-dom";
import { useEffect } from "react";
import Header from "./Header";
import Footer from "./Footer";
import { useAppDispatch, useAppSelector } from "@/store/store";
import { fetchUserDetails } from "@/store/feature/UserSlice";

const Layout: React.FC = () => {
  const dispatch = useAppDispatch();
  const user = useAppSelector((state) => state.user.user);
  const userDetailsLoading = useAppSelector(
    (state) => state.user.userDetailsLoading
  );

  useEffect(() => {
    if (!user && userDetailsLoading === "idle") {
      dispatch(fetchUserDetails());
    }
  }, [dispatch, user, userDetailsLoading]);

  return (
    <div className="min-h-screen bg-[#f1f1f1] flex flex-col">
      <Header />
      <main className="flex-1 px-4 sm:px-6 py-6 max-w-7xl mx-auto w-full relative">
        <div className="absolute top-0 left-0 right-0 h-64 bg-linear-to-b from-blue-50/50 to-transparent pointer-events-none" />
        <div className="relative z-10">
          <Outlet />
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default Layout;